var React = require('react');

function BeltPinchInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M969.742 116.182H756.309C688.059 44.6318 591.675 0 484.871 0C378.068 0 281.684 44.6318 213.26 116.182H0V634.396H213.26C281.684 705.946 378.068 750.578 484.871 750.578C591.675 750.578 688.059 705.946 756.482 634.396H969.742V116.182Z","className":"solid","fill":"black","key":0}),React.createElement("path",{"d":"M485.246 165.735C583.623 165.735 671.97 121.867 731.452 52.6699H900.863V697.909H733.404C673.771 627.364 584.823 582.598 485.246 582.598C385.668 582.598 296.72 627.364 237.087 697.909H68.8799V52.6699H239.039C298.52 121.867 386.718 165.735 485.246 165.735Z","className":"outline","stroke":"white","strokeWidth":"2","key":1})]);
}

BeltPinchInline.defaultProps = {"width":"970","height":"751","viewBox":"0 0 970 751","fill":"none"};

module.exports = BeltPinchInline;

BeltPinchInline.default = BeltPinchInline;
